"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcomeSchemaProperties = exports.OutcomeSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const OutcomeStatusEnum = zod_1.z.enum(["active", "deleted"]);
const OutcomeCategoryEnum = zod_1.z.enum([
    "cancelled_outside_window",
    "cancelled_inside_window",
    "cancelled",
    "rescheduled",
    "no-show",
    "completed",
    "non-billable",
]);
exports.OutcomeSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string(),
    status: OutcomeStatusEnum,
    category: OutcomeCategoryEnum,
    color: zod_1.z.object({
        background: zod_1.z.string(),
        foreground: zod_1.z.string(),
    }),
    order: zod_1.z.number(),
    icon: zod_1.z.string(),
    isDefault: zod_1.z.boolean(),
});
exports.OutcomeSchemaProperties = {
    collectionName: "outcomes",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=outcome-schema.js.map